<template>
  <div class="container">
    <div class="right">
      <span
        @click="abrirModal()"
        class="btn btn-small button-larges btn-sobre z-depth-3 cor-primaria-bg">Sobre a loja</span
      >
    </div>
    <div class="funcionamento">
      <a class="icones-empresa" :href="this.$store.state.empresa.empresa_whatsapp_link" target="_blank" v-if="this.$store.state.empresa.receber_pedidos_whatsapp == 'S'">
        &nbsp;<i class="fab fa-whatsapp " style="padding-right: 7px;font-size: 23px"></i>
        {{ this.formatarWhats() }}
      </a>

      <div v-if="this.$store.state.empresa.habilitar_entrega == 'S'" class="icones-empresa">
        <span class="material-icons md-24">schedule</span>
        ENTREGA - {{ this.$store.state.empresa.tempo_medio_entrega ? this.$store.state.empresa.tempo_medio_entrega.toUpperCase() : '' }}
      </div>
      <a class="icones-empresa" :href="this.$store.state.empresa.empresa_endereco_link" target="_blank">
        <span class="material-icons md-24">location_on</span>
        {{this.$store.state.empresa.empresa_endereco_completo}}
      </a>
      <div v-if="this.$store.state.empresa.habilitar_entrega == 'S'" class="icones-empresa">
        <span class="material-icons md-24">motorcycle</span>
        ENTREGA &nbsp; -
        &nbsp;
        <b>{{this.$store.state.empresa.empresa_frete_detalhes}}</b>
      </div>
      <div v-if="this.$store.state.empresa.valor_minimo_entrega > 0" class="icones-empresa">
        <span class="material-icons md-24">attach_money</span>
        <b>Valor min. para Entrega: R$ {{this.$store.state.empresa.valor_minimo_entrega.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</b>
      </div>

      <span v-if="this.$store.state.empresa.aberto == 'S'" class="a-status materialize-green">ABERTO</span>
      <span v-else class="a-status materialize-red">FECHADO</span>
    </div>

    <!-- Modal Structure -->
    <div id="modalHorarios" class="modal modal-fixed-footer">
      <div class="modal-content">
        <div class="row">
          <h5 class="col s12 center-align" style="margin-top: 0">
            Sobre a Loja
          </h5>
        </div>

        <titulo-destacado :titulo="this.$store.state.empresa.nome"></titulo-destacado>

        <div class="row">
          <span class="col s12">
            <strong>Endereço: {{this.$store.state.empresa.empresa_endereco_completo}}</strong>
          </span>
        </div>

        <titulo-destacado titulo="Horário de Atendimento"></titulo-destacado>
        <ul v-if="this.$store.state.empresa.forma_exibicao_horario == 'TABELA'">
          <li
            v-for="horario in this.$store.state.empresa.horarios"
            :key="horario.dia"
            :class="
              'horarios row' +
              ($store.state.empresa.dia_semana == horario.dia
                ? ' text-bold'
                : '')
            "
          >
            <span class="col s3">{{ horario.descricao }}</span>
            <span class="col s9">{{ horario.horarios == "00:00 às 23:59" ? "Aberto 24 horas" : horario.horarios }}</span>
          </li>
        </ul>
        <div v-else class="row">
          <span class="col s12">
            {{
              this.$store.state.empresa.horario_funcionamento ? this.$store.state.empresa.horario_funcionamento.toLocaleUpperCase() : ""
            }}
          </span>
        </div>

        <titulo-destacado titulo="Formas de Pagamento"></titulo-destacado>

        <div class="row">
          <span
            class="col s12"
            v-if="this.$store.state.empresa.pagamento_dinheiro == 'S'"
            >Dinheiro</span
          >
          <span
            class="col s12"
            v-if="this.$store.state.empresa.pagamento_mercadopagolink == 'S'"
            >Link de Pagamento Online</span>
          <span
            class="col s12"
            v-if="this.$store.state.empresa.pagamento_debito == 'S'"
            >Cartão de Débito</span
          >
          <span
            class="col s12"
            v-if="this.$store.state.empresa.pagamento_credito == 'S'"
            >Cartão de Crédito</span
          >
          <span
            class="col s12"
            v-if="this.$store.state.empresa.pagamento_transferencia == 'S'"
            >Transferência</span
          >
          <span
            class="col s12"
            v-if="this.$store.state.empresa.pagamento_pix == 'S'"
            >PIX</span>
        </div>
      </div>
      <div class="modal-footer cor-primaria-border">
        <a class="modal-close waves-effect btn-flat cor-primaria-text">Fechar</a>
      </div>
    </div>
  </div>
</template>

<script>
import TituloDestacado from "./TituloDestacado";

export default {
  name: "InformacoesEmpresa",
  data() {
    return {
      empresa: this.$store.state.empresa,
      tarifaEntregaMinima: 0,
    };
  },
  components: { TituloDestacado },
  methods: {
    formatarWhats() {
      var numero = this.$store.state.empresa.whatsapp;

      if (numero.startsWith("55")) numero = numero.slice(2);

      if (numero.length < 10) return numero;

      numero = numero.replace(/^(\d{2})(\d)/g, "($1) $2");
      numero = numero.replace(/(\d)(\d{4})$/, "$1-$2");

      return numero;
    },
    abrirModal() {
      $("#modalHorarios").modal("open");
    },
  },
  mounted() {
    $("#modalHorarios").modal();
    var tarifas = this.$store.state.empresa.tarifas_entrega_bairro;
    if (tarifas.length > 0) {
      this.tarifaEntregaMinima =
        " R$ " +
        tarifas
          .reduce((min, b) => Math.min(min, b.valor), tarifas[0].valor)
          .toFixed(2);
    }
  },
};
</script>

<style scoped>
.modal {
  top: 3% !important;
  width: 94% !important;
  max-width: 100% !important;
  height: 94% !important;
  max-height: 100% !important;
}
.modal .modal-content {
  margin-top: 4px;
  padding: 0 5px !important;
}
.modal .modal-content ul,
.modal .modal-content div.row {
  margin: 0;
  padding: 12px 0px;
}
.modal .modal-content ul li,
.modal .modal-content div.row span {
  margin-bottom: 8px;
}
.horarios {
  font-size: 1em;
}
.funcionamento {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px 5px 0px;
  margin: 0px auto;
}
.a-status {
  position: absolute;
  right: 12px;
  top: 12px;
  padding: 8px;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  -webkit-box-pack: center;
  justify-content: center;
  color: white;
  white-space: nowrap;
}
.icones-empresa {
  display: flex;
  flex-direction: row;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  align-items: start;
  line-height: 2;
  font-size: 0.9rem;
  margin-bottom: 8px;
}
.icones-empresa .material-icons,
.icones-empresa svg {
  margin-right: 8px;
}
.btn-sobre {
  position: absolute;
  top: 160px;
  right: 27%;
}

@media screen and (max-height: 823px) {
  .btn-sobre {
    top: 140px;
    right: 8%;
  }
}

@media screen and (max-height: 640px) {
  .btn-sobre {
    top: 140px;
    right: 8%;
  }
}
@media screen and (max-height: 540px) {
  .btn-sobre {
    top: 120px;
    right: 8%;
  }
}

@media screen and (max-width: 375px) {
  .horarios {
    font-size: 0.9em;
  }
}

.button-larges{
  text-decoration: none;
  display: inline-block;
  text-align:center;
  font-size: 10px;
  line-height: 15px;
  padding: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Widgets/InformacoesEmpresa.vue